import React, { useEffect, useState } from 'react'
import { Logo } from '../../components/Logo'
import { useDispatch, useSelector } from 'react-redux';
import { loadingAction, log, logRepresentante } from '../../store/actions/login.actions';
import websapp from '../../assets/webceleste.png'
import 'animate.css';
import googleplay from '../../assets/googleplay.png'
import appstore from '../../assets/appstore.png'
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'
import { Loading } from '../../components/Loading';
import eye from '../../assets/eye-outline.svg'
import eyeOff from '../../assets/eye-off-outline.svg'




export const LoginRepresentante = () => {

  let navigate = useNavigate();

  const [portal, setPortal] = useState("")
  const [usuario, setUsuario] = useState("")
  const [px, setPx] = useState("")
   
  

  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)

  const sign = () => {

 

    if(portal === '' || usuario ==='' || px === '' ){
        
        Swal.fire({
          title: 'Completa todos los campos',
          text: 'Intentalo otra vez',
          confirmButtonColor:'#2ec1db',
        })

        return
    }
  
  
    localStorage.removeItem('empresaId')
 
    setLoading(true)
    dispatch(logRepresentante(portal,usuario,px,setLoading,navigate))
    

}

  // const sign =() => {

  //   if(pe === '' || px === '' ){
  //     Swal.fire({
  //       title: 'Completa todos los campos',
  //       text: 'Intentalo otra vez',
  //       confirmButtonColor:'#2ec1db',
        
  //     })
  //       return
  //   }
    
  //   //  console.log('pasaporaca')
  //   localStorage.removeItem('empresaId')

  //   setLoading(true)

  //   dispatch(log(pe,px,setLoading,navigate))
    
    
  // }





  const pressEnter = (e) => {
    if(e.key === 'Enter'){
      sign()
    }

  }

  const [mostrar, setmostrar] = useState('password')


  const ver = () => {

    if(mostrar === 'text'){

        setmostrar('password')

        return
    }

    if(mostrar === 'password'){

        setmostrar('text')
        
        return
    }

  }



  return (
    

    
    <div className={loading ? 'nada' : 'container'} >

        {
          loading ? <div className='marginTopLoading' ><Loading/>
          </div>  :
          <>
        <div className='containerLogin animate__animated animate__fadeIn'>

                    <div className='contenedorLogo'>
                          <Logo/>

                    </div>

                    <div className='iniciar' >
                          <p>Inicia Sesión en <span>WebSal</span></p>
                     </div> 
                  

                    

                  <div className='contenedorInput' >

                                <label > Portal </label>
                                <input type='text' value={portal} onChange={e => setPortal(e.target.value) } />
                              
                                 
                                <label > Usuario </label>
                                <input type='text' value={usuario} onChange={e => setUsuario(e.target.value) } />
                              
                                 
                                      

                                <label> Contraseña </label>
                                <div className='contenedorClaveOjo'>

                                    <input type={mostrar} onKeyPress={pressEnter} value={px} onChange={e => setPx(e.target.value) } />
                                    
                                    <button className='mostrarBtnLogin' onClick={() => ver() } >
                                          <img className='ver' src={ mostrar === 'password' ? eye : eyeOff } alt='ver' />
                                    </button>


                                </div>

                                
                                <button type='button' className='ingresar' onClick={ sign} >
                                  <p>Ingresar</p> 
                                </button> 
                                
                       

                  </div>


                  <div className='contenedorOptionsLogin' >

                     

                                <button onClick={ () => navigate('/') } className='recuperarClave' >
                                  <p className='textoPrimeraVez representanteEmpresa' > Ingresar como colaborador  </p> 
                                </button>



                  </div>






            </div>

            <div className='contenedorAppLogin' >
              
              <div className='contenedorWebApp' > 
                    <img src={websapp} width='160' />

              </div>


                <p className='primer' >Descargar la App de Autoconsulta </p>
                <p className='frase' >Accede a tus datos laborales donde y cuando quieras</p>
              

                <p >Encuentrala en:</p>
              <div className='contendorAppstores' >
                
                    <a href='https://play.google.com/store/apps/details?id=com.appwebsal' target='_blank'  >
                      <img src={googleplay} />

                    </a>
                
                {/* Para cuando ya este en la playstore */}

                
                <a href='https://apps.apple.com/cl/app/websal/id1627284767' target='_blank' >
                <img className='appstore' src={appstore}  />


                </a>

                
              </div>

          
        

        </div>

          

          
          </>
        }


     


    </div>


  )
}
